import Highcharts from "highcharts";
import Highstock from "highcharts/highstock";

/**
 * 모든 차트 공통 기본값. 화면이 따로 지정한 값이 있으면 그 값이 우선한다.
 * - y축 선: 눈금 글자가 붙는 축 선을 그린다(Highcharts 기본은 0)
 * - 마커: 계열마다 모양이 바뀌는 기본 동작(원·마름모·네모·세모) 대신 모두 원
 * highcharts 와 highcharts/highstock 은 서로 다른 인스턴스라 둘 다 설정한다.
 */
// 선·영역 계열에만 건다. series 전체에 걸면 히트맵 칸까지 원으로 바뀐다
const CIRCLE = { marker: { symbol: "circle" } };

const defaults: Highcharts.Options = {
  yAxis: { lineWidth: 1, lineColor: "#E1E1E1" },
  plotOptions: { line: CIRCLE, spline: CIRCLE, area: CIRCLE, areaspline: CIRCLE, scatter: CIRCLE },
};

Highcharts.setOptions(defaults);
Highstock.setOptions(defaults);
